import script from "./BenefitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitForm.vue?vue&type=script&setup=true&lang=js"

import "./BenefitForm.vue?vue&type=style&index=0&id=382e3ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382e3ff8"]])

export default __exports__